import { io, type Socket } from 'socket.io-client';
import { API_BASE_URL } from '@/config/apiBaseUrl';

function socketOrigin(): string {
  const base = API_BASE_URL;
  if (base.startsWith('http://') || base.startsWith('https://')) {
    return base.replace(/\/api\/v1\/?$/, '');
  }
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}

let socket: Socket | null = null;

export function getNotificationSocket(): Socket | null {
  return socket;
}

export function connectNotificationSocket(token: string): Socket | null {
  if (!token) return null;
  if (socket?.connected) return socket;
  const origin = socketOrigin();
  if (!origin) return null;
  socket = io(origin, {
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
  });
  return socket;
}

export function disconnectNotificationSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
